import { render, staticRenderFns } from "./Ledger.vue?vue&type=template&id=66acd394&"
import script from "./Ledger.vue?vue&type=script&lang=js&"
export * from "./Ledger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\manla\\Downloads\\b\\public_html\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66acd394')) {
      api.createRecord('66acd394', component.options)
    } else {
      api.reload('66acd394', component.options)
    }
    module.hot.accept("./Ledger.vue?vue&type=template&id=66acd394&", function () {
      api.rerender('66acd394', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/Ledger.vue"
export default component.exports